import Inquiry from "./Inquiry";

const Contact = () => {
  return (
    <div id="contact" className="relative w-full h-full mx-auto pb-14 lg:pb-28 xl:pb-36">
      <div className=" relative w-full h-fit text-white py-7 lg:py-14">
        <img src="/images/contactTitle.png" alt="title" className="absolute left-0 top-0 w-full h-full" />
        <div id="title" className="relative w-full h-fit text-center">
          <h3 className="font-medium lg:text-3xl">상세 견적문의</h3>
          <p className="text-point pt-1 pb-6">- Contact -</p>
          <h2 className="hidden lg:block font-medium leading-tight">
            지금 바로 전문가와 무료 상담해보세요!
            <br />
            깔끔하고 확실하게 해결해드립니다.
          </h2>
          <h4 className="block lg:hidden font-medium leading-tight">
            지금 바로 전문가와 무료 상담해보세요!
            <br />
            깔끔하고 확실하게 해결해드립니다.
          </h4>
        </div>
      </div>
      <div className="my-8 lg:my-12">
        <p className="text-center">
          소중한 문의 남겨주셔서 감사합니다.
          <br />
          전문 담당자가 확인 후 빠르고&nbsp;친절한&nbsp;상담&nbsp;도와드리겠습니다
        </p>
        <div className="hidden xl:block relative w-fit h-fit max-w-96 3xl:max-w-none mx-auto mt-10">
          <img
            onClick={() => {
              window.location.href = "tel:010-9368-5332";
            }}
            className="!relative w-full h-full max-h-12 3xl:max-h-14 object-contain cursor-pointer"
            alt="button"
            src={"images/rightNum.png"}
            width={532}
            height={132}
          />
        </div>
      </div>
      <div className="relative w-full h-fit px-[calc((100%-var(--container))/2)] max-w-[1600px] mx-auto ">
        <Inquiry />
      </div>
    </div>
  );
};

export default Contact;
